import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getReportGroups(dealer_location_id) {
    return axios.post(ENV.reportsBaseUrl + "/locations/list_groups", { dealer_location_id }, this.requestConfig());
  }

  static getReportList(dealer_location_id, group) {
    return axios.post(ENV.reportsBaseUrl + "/locations/list", { dealer_location_id, group }, this.requestConfig());
  }

  static getReportData(dealer_location_id, report_id, date_from, date_to) {
    return axios.post(ENV.reportsBaseUrl + "/locations/view", { dealer_location_id, report_id, date_from, date_to }, this.requestConfig());
  }
}

export default Service;
